import { Helmet } from "react-helmet-async";

const SITE_URL = "https://thephilosophertest.com";
const DEFAULT_OG = `${SITE_URL}/og-default.png`;

/**
 * Per-route <head> for SEO. All fields are optional except `path` (used to
 * build the canonical URL). When `noindex` is true, the page is excluded from
 * search engines — used for /quiz, /result, /report, /payment, /admin.
 */
export default function SEOHead({
  title,
  description,
  path,
  noindex = false,
  jsonLd = null,
  ogImage,
}) {
  const canonical = `${SITE_URL}${path || "/"}`;
  const finalTitle = title
    ? `${title} · The Philosopher Test`
    : "The Philosopher Test — Which philosopher thinks like you?";
  const finalDescription =
    description ||
    "20 questions. 3 minutes. Discover which of the 8 greatest philosophers thinks like you. Free character sheet, shareable card.";
  const finalOg = ogImage || DEFAULT_OG;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={canonical} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large" />
      )}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={finalOg} />
      <meta property="og:site_name" content="The Philosopher Test" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalOg} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
